import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IpoAbstractApiEndpoint } from '@ip-only/front-end-library';
import { Observable } from 'rxjs';
import { AddressSearchResponse } from './entities/address-search';
import { OpportunitiesForAddressResponse } from './entities/opportunity-address-suggestions';
import { OpportunityDetails } from './entities/opportunity-details';

const ADDRESS_SEARCH = '/address-search/suggestions';
const OPPORTUNITY_ADDRESS_SUGGESTION =
  '/address-search/opportunity-address-suggestions';
const OPPORTUNITY_DETAILS = '/address-search/opportunity-details/';

@Injectable({
  providedIn: 'root',
})
export class AddressSearchApiService {
  constructor(private http: HttpClient) {}

  getAddressSearchSuggestions =
    new (class extends IpoAbstractApiEndpoint<AddressSearchResponse> {
      protected handleRequest(
        address: string
      ): Observable<AddressSearchResponse> {
        const url = `${environment.backendBaseUrl}/v1/public${ADDRESS_SEARCH}?address=${address}`;

        return this.http.get<AddressSearchResponse>(url);
      }
    })(this.http, null);

  getOpportunitiesForAddress =
    new (class extends IpoAbstractApiEndpoint<OpportunitiesForAddressResponse> {
      protected handleRequest(
        address: string,
        magicKey: string
      ): Observable<OpportunitiesForAddressResponse> {
        const url = `${environment.backendBaseUrl}/v1/public${OPPORTUNITY_ADDRESS_SUGGESTION}?address=${address}&magicKey=${magicKey}`;

        return this.http.get<OpportunitiesForAddressResponse>(url);
      }
    })(this.http, null);

  getOpportunityDetailsById =
    new (class extends IpoAbstractApiEndpoint<OpportunityDetails> {
      protected handleRequest(
        opportunityId: string
      ): Observable<OpportunityDetails> {
        return this.http.get<OpportunityDetails>(
          `${environment.backendBaseUrl}/v1/public${OPPORTUNITY_DETAILS}${opportunityId}`
        );
      }
    })(this.http, null);
}
